import { Component, OnInit, Input, ChangeDetectorRef, OnDestroy } from '@angular/core';
import { CommonService } from 'src/app/services/common.service';
import { AskApolloService } from 'src/app/services/ask-apollo.service';
import { CallCenterService } from 'src/app/services/call-center.service';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import{ CommonMethods } from 'src/app/shared/CommonMethods'; 
import { Speciality } from 'src/app/models/common-model';
import { Subscription } from 'rxjs';
import { MessageServiceService } from 'src/app/services/message-service.service';
@Component({
  selector: 'app-general-enquiry',
  templateUrl: './general-enquiry.component.html',
  styleUrls: ['./general-enquiry.component.scss']
})
export class GeneralEnquiryComponent implements OnInit,OnDestroy {
  callerStatusAutoId;
  selectedCallStatusId;
  selectedCallStatusName;
  selectedUHIDDetails;
  generalEnquiryForm: FormGroup;
  selectedCallStatus$ : Subscription;
  selectedAppointmentType = 1;
  selectedHospitalType=2;

  leadSourcesData : any [] = [
    {label:'Cradle near to work place', value:'Cradle near to work place'},
    {label:'Doctor Referral', value:'Doctor Referral'},
    {label:'E-Mailers', value:'E-Mailers'},
    {label:'Existing Apollo Cradle Patient', value:'Existing Apollo Cradle Patient'},
    {label:'Family and Friends', value:'Family and Friends'},
    {label:'Hoardings / Outdoor Media', value:'Hoardings / Outdoor Media'},
    {label:'Just Dail', value:'Just Dail'},
    {label:'Lybrate', value:'Lybrate'},
    {label:'Marketing', value:'Marketing'},
    {label:'NewPaper', value:'NewPaper'},
    {label:'Online / Google', value:'Online / Google'},
    {label:'Other - Apollo Franchise', value:'Other - Apollo Franchise'},
    {label:'Practo', value:'Practo'},
    {label:'SMS', value:'SMS'},
    {label:'Social Media', value:'Social Media'},
    {label:'Stays near Cradle', value:'Stays near Cradle'},
    {label:'Website', value:'Website'},
    
  ]

  constructor(private commonService: CommonService,
              private askApolloService: AskApolloService,
              private formBuilder: FormBuilder,
              private callCenterService: CallCenterService,
              private messageService: MessageServiceService,
              private ref: ChangeDetectorRef, ) 
  {
    //this method get the selected call status data from service
    this.selectedCallStatus$ = this.callCenterService.selectedCallStatus.subscribe(value => {
      this.callerStatusAutoId = value.CallerStatusAutoId;
      this.selectedUHIDDetails = value.UHIDDetails;      
      this.selectedCallStatusId = value.CallStatus["callCenterStatusId"];
      this.selectedCallStatusName = value.CallStatus["statusName"];
    });
    
  }

  ngOnInit() {
    this.generalEnquiryForm = this.formBuilder.group({
      name: ['', Validators.required],
      email: ['', Validators.required],
      mobileNo: ['', Validators.required],
      countryCode: ['', Validators.required],
      city: ['', Validators.required],
      clinic: ['', Validators.required],
      speciality: ['', Validators.required],
      address:[''],
      leadSource: [''],
     // campaign: [''],
      notes:[''],     
      //leadStage:[''],
      //leadOrigin:[''],
      followUpTime:[''],
      followUpDate:['']
    });
    this.getAllLeadSources();
    this.getAllCities(this.selectedAppointmentType);
    this.getAllCountryCodes();
  }

  ngOnDestroy(): void {
    this.selectedCallStatus$.unsubscribe();
  }

  citiesData: any[];
  clinicsData: any[];
  getAllCities(apptType) {
    this.loadingFlag= true;
    this.generalEnquiryForm.get('clinic').setValue('');
    this.generalEnquiryForm.get('speciality').setValue('');
    this.askApolloService.getAllCities(apptType, this.selectedHospitalType)  // appttype, hospitaltype
      .subscribe((res: any) => {
        //console.log('cities: ',res.response.citiesList);
        if(res && res.response && res.response.citiesList && res.response.citiesList.length>0){
          this.citiesData = res.response.citiesList;
        }else{
          this.citiesData = [];
        }
        this.loadingFlag= false;
      }, error => {
        this.loadingFlag= false;
        this.messageService.showError();
      })
  }
  selectedCity;
  getClinicsOnCityId(cityId) {
    this.clinicsData = [];
    this.specialitiesData =[];
    //this.generalEnquiryForm.get('clinic').setValue('');
    this.generalEnquiryForm.get('speciality').setValue('');
    if (cityId) {
      this.loadingFlag= true;
      this.selectedCity = cityId;
      this.askApolloService.getClinicsOnCityId(this.selectedAppointmentType, this.selectedHospitalType, cityId)  // appttype, hospitaltype, cityid
        .subscribe((res: any) => {
          //console.log("Hospitals:", res);
          this.loadingFlag= false;
          if (res.response.hospitalList.length > 0) {
            this.clinicsData = res.response.hospitalList;
          }else{
            this.clinicsData =[];
          }
        }, error => {
          this.messageService.showErrorMessage("Unable to retrieve clinics data from server ");
          this.loadingFlag= false;
        })
    }
  }

  isLoading: false;
  leadSources:any = [];
  getAllLeadSources() {
    this.loadingFlag= true;
    this.commonService.getAllLeadSources()
      .subscribe((res: any) => {
        if (res.response.length > 0){
          this.leadSources = res.response;
        }
        else{
          this.leadSources=[];
        }
        this.isLoading= false;
        //this.selectedLeadSourceID =1;
      }, error => {
        this.isLoading= false;
        this.messageService.showErrorMessage("Unable to retrieve leadsource data from server ");
      })
  }
  
  get f() { return this.generalEnquiryForm.controls; }

  isSubmitted = false;
  loadingFlag: boolean = false;
  submitGeneralEnquiry(formData) {
    let formDataValues = this.generalEnquiryForm.value;
    if (this.generalEnquiryForm.invalid) {
      return;
    }
    this.loadingFlag= true;
    let payload = {
      "contactId": 0,
      "fullName": formDataValues.name,
      "email": formDataValues.email,
      "mobileNumber": formDataValues.mobileNo,
      "countryCode": formDataValues.countryCode,
      "cityId": +formDataValues.city,
      "clinicId": +formDataValues.clinic,
      "specialityId": +formDataValues.speciality,
      "address": formDataValues.address,
      "leadSource": formDataValues.leadSource,
      "leadStage": '',//formDataValues.leadStage,
      "campaign": '',//formDataValues.campaign,
      "notes": formDataValues.notes,
      "followUpDate": CommonMethods.changeDateFormatDDMMYYYY(formDataValues.followUpDate),
      "followUpTime": new Date(formDataValues.followUpTime).getHours() +":"+new Date(formDataValues.followUpTime).getMinutes(),
      "createdBy": 0,
      "createdIp": "string",
      "callerAutoId": this.callerStatusAutoId,
      "callStatusId": this.selectedCallStatusId,
      "statusRemarks": formDataValues.notes,
      "isActivityLead": localStorage.getItem("IsActivityLead") == 'true' ? true : false
    }

    this.askApolloService.InsertGeneralEnquiryDetails(payload)
      .subscribe((res: any) => {
        this.loadingFlag= false;
        if (res.isSuccess) {
          if(res.response  !=null){
            this.messageService.showSuccess(res.response['result'].statusMessage)
            this.callCenterService.afterCompleteOperationKnowTheStatus({
              "callStatusId": this.selectedCallStatusId,
              "callStatusName": this.selectedCallStatusName,
              "isOperationDone": true,
              "statusMessage": "General Enquiry Details Added Successfully."
            });
          }
        }
      }, error => {
        this.messageService.showErrorMessage("Unable to add data, An error occur while adding data.");
        this.loadingFlag= false;
      })
  }

  specialitiesData:any[] = [];
  getSpecialities(hospitalId){
    this.specialitiesData = [];
    if (hospitalId) {      
      this.loadingFlag= true;
      this.askApolloService.getSpecialitiesOnHospitalId(this.selectedHospitalType, hospitalId)  // hospitaltype, hospitalid
        .subscribe((res: any) => {
          //console.log("spec:", res);
          if (res.response.specilaityList.length > 0) {
            this.specialitiesData = res.response.specilaityList;
          }else{
            this.specialitiesData = [];
          }
          this.loadingFlag= false;
        }, error => {
          this.messageService.showErrorMessage("Unable to retrieve speciality data from server ");
          this.loadingFlag= false;      
        })
    }
  }

  filterCountryCode ="-1";
  countryCodes : any[] = [];
  filterCountryCodesInTable:any[] = [];
  getAllCountryCodes() {
    this.commonService.getCountryCodes() .subscribe((res: any) => {

      this.filterCountryCodesInTable.push({label:"All",value:-1});
      for(var key in res) {
        res[key].calling_code = "+"+res[key].calling_code;
        this.countryCodes.push(res[key]);
        let temp =  { label: res[key].name+ ' ('+res[key].calling_code+')', value: res[key].calling_code };
        this.filterCountryCodesInTable.push(temp);        
      }
      this.filterCountryCode = "-1";
    });
    
  }
}
